var $56c9dcbf8ca8b307$exports = {};
/**
 * Copyright © VNG Realisatie 2024
 * Licensed under the EUPL
 */ $56c9dcbf8ca8b307$var$enableCopyOnClick();
document.body.addEventListener('htmx:afterSettle', function() {
    $56c9dcbf8ca8b307$var$enableCopyOnClick();
});
function $56c9dcbf8ca8b307$var$enableCopyOnClick() {
    document.querySelectorAll('[data-copy-on-click]').forEach((el)=>{
        // first remove the listener in case it was added in a previous HTML request
        el.removeEventListener('click', $56c9dcbf8ca8b307$var$onClickHandler);
        el.addEventListener('click', $56c9dcbf8ca8b307$var$onClickHandler);
    });
}
function $56c9dcbf8ca8b307$var$onClickHandler(event) {
    $56c9dcbf8ca8b307$var$copyTextFromElementToClipboard(event.currentTarget.dataset.copyOnClick);
    event.preventDefault();
}
function $56c9dcbf8ca8b307$var$copyTextFromElementToClipboard(elementID) {
    const text = document.getElementById(elementID).innerText.trim();
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text);
    else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
        document.body.prepend(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
        } catch (error) {
            console.error(error);
        } finally{
            textArea.remove();
        }
    }
}


//# sourceMappingURL=controller.cf9c142d.js.map
